export enum Align {
  Right = 'right',
  Left = 'left',
  Center = 'center',
  Inherit = 'inherit',
  FlexStart = 'flex-start',
}
